import { useEffect, useState, useRef } from "react";
import { 
    Button, Card, CardActions, CardMedia, Drawer, Grid, Typography 
} from '@mui/material';
import Helpers from "../Helpers";
import noImage from '../images/noimage.png';
import axios from "axios";


function ModalImgProduto({ open, onClose, item }){
    const inputFile = useRef(null);
    const [urlApi, setUrlApi] = useState(process.env.REACT_APP_URL_API);
    const [imgProduto, setImgProduto] = useState(null);
    const [produto, setProduto] = useState({
        registro_id: 0,
        arquivo: null,
    });

    const renderImage = (item)=>{
        let newImg = item.imagem;

        if(newImg !== null){
            setImgProduto(newImg);
        }else{
            setImgProduto(noImage);
        }

        setProduto((prevState) => ({ ...prevState, registro_id: item.id }));
    };

    const handleAddFotos = ()=>{
        const input = document.getElementById('input_file');
        input.click();
    };

    const handleSelectImg = (arquivo) => {
        const file = arquivo;

        if (!file) return;

        setProduto((prevState) => ({ ...prevState, arquivo: file }));

        // Cria uma URL temporária da imagem para exibir no <img>
        const imageUrl = URL.createObjectURL(file);
        setImgProduto(imageUrl);
    };

    useEffect(()=>{
        if(item !== null){
            renderImage(item);
        }
    }, [item]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        let alertaForm = {};

        if(produto.arquivo == null){
            alertaForm = {
                title: 'Atenção! Nenhuma imagem selecionada',
                icon: 'warning',
                href: null
            };
            Helpers.toastAlert(alertaForm);
        }else{
            const route = `${urlApi}/update_imagem_produto`;

            await axios.post(route, produto, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                }
            })
            .then(function (response) {
                Helpers.toastAlert(response.data.validation);
                window.location.reload();
            }).catch(function (error) {
                alertaForm = {
                    title: 'Atenção!!!',
                    text: error.message,
                    icon: 'warning',
                    href: null
                };
                Helpers.showAlert(alertaForm);
            });
        }
    };

    return (
        <>
        {
            item && (
                <Drawer
                    anchor="bottom"
                    open={open}
                    onClose={onClose}
                >
                    <Grid container justifyContent="center" rowSpacing={3}>
                        <Grid 
                            item 
                            size={12}
                            sx={{ 
                                height: 50,
                                paddingX: 2, 
                                display: 'flex', 
                                flexDirection: 'row', 
                                justifyContent: 'space-between',  
                                alignItems: 'center',
                                borderBottom: '1px solid #ccc'
                            }}
                        >
                            <Typography
                                sx={{
                                    fontWeight: 'bold',
                                    fontSize: 15,
                                }}
                            >
                                {item.nome}
                            </Typography>
                            <Button 
                                onClick={onClose}
                                sx={{
                                    backgroundColor: '#DA0C16',
                                    color: '#f5f5f5'
                                }}
                            >
                                x
                            </Button>
                        </Grid>

                        <Grid item size={{ xs: 12, md: 6 }} sx={{ width: '100%' }}>
                            <Card sx={{ width: '100%', height: 'auto' }} >
                                <CardMedia                                    
                                    sx={{ height: 200, backgroundPosition: 'center', backgroundSize: 'contain' }}
                                    image={imgProduto}
                                    title={item.nome}
                                    onClick={handleAddFotos}
                                />
    
                                <CardActions sx={{ display: 'flex', justifyContent: 'center' }}>
                                    <input 
                                        id={'input_file'} 
                                        type="file" 
                                        ref={inputFile} 
                                        onChange={(e)=>handleSelectImg(e.target.files[0])} 
                                        style={{ display: 'none' }} 
                                    />
                                    
                                    <Button 
                                        variant="contained"
                                        size="medium" 
                                        onClick={handleSubmit}
                                    >
                                        atualizar 
                                    </Button>
                                </CardActions>
                            </Card>
                        </Grid>
                    </Grid>
                </Drawer>
            )
        }
        </>
    );
}

export default ModalImgProduto;